var _rect, _path, _rect2, _path2, _rect3, _path3, _rect4, _path4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirstAvailableIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 43,
    viewBox: "0 0 48 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25977,
    y: 3.64417,
    width: 45.4779,
    height: 38.8382,
    rx: 3.5,
    stroke: "#858585"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M1.88477 7.59137C1.88477 5.92703 3.23962 4.5808 4.90393 4.59143L43.9578 4.84094C45.1213 4.84837 46.0329 5.84351 45.9385 7.00316L45.8229 8.42294V11.9436H1.88477V7.59137Z",
    fill: "#858585"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 15.5,
    width: 9,
    height: 9,
    rx: 4.5,
    fill: "#A8A8A8",
    stroke: "#A8A8A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 19.8284L8.49289 21.1639L11.2426 18.4142",
    stroke: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 15.5,
    width: 9,
    height: 9,
    rx: 4.5,
    fill: "#A8A8A8",
    stroke: "#A8A8A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 19.8284L23.4929 21.1639L26.2426 18.4142",
    stroke: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 15.5,
    width: 9,
    height: 9,
    rx: 4.5,
    fill: "#A8A8A8",
    stroke: "#A8A8A8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37 19.8284L38.4929 21.1639L41.2426 18.4142",
    stroke: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 28.5,
    width: 9,
    height: 9,
    rx: 4.5,
    fill: "#A8A8A8",
    stroke: "#A8A8A8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 28.5,
    width: 9,
    height: 9,
    rx: 4.5,
    fill: "#A8A8A8",
    stroke: "#A8A8A8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 28.5,
    width: 9,
    height: 9,
    rx: 4.5,
    fill: "#A8A8A8",
    stroke: "#A8A8A8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8267,
    y: 0.931274,
    width: 2.21362,
    height: 5.53405,
    fill: "#858585"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 33.9595,
    y: 0.928955,
    width: 2.21362,
    height: 5.53405,
    fill: "#858585"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 0.759766,
    y: 11.9957,
    width: 46.4779,
    height: 1.10681,
    fill: "#858585"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 32.8284L8.49289 34.1639L11.2426 31.4142",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 32.8284L23.4929 34.1639L26.2426 31.4142",
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37 32.8284L38.4929 34.1639L41.2426 31.4142",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstAvailableIcon);
export default __webpack_public_path__ + "static/media/firstAvailableIcon.23fa2c947d3c369c635a6940e5162410.svg";
export { ForwardRef as ReactComponent };